/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ChevronUpIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "chevron-up", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M8 15L12.5 9.5L17 15", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ChevronUpIcon);
export default ForwardRef;
//# sourceMappingURL=chevronUpIcon.js.map